import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "snsUnlinkCompleteDialog",
  tabindex: "-1",
  "aria-labelledby": "updateUserComplete",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-md" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title w-100 text-center fw-bold" }
const _hoisted_6 = {
  key: 0,
  class: "text-center my-4 px-4"
}
const _hoisted_7 = { class: "modal-footer d-flex justify-content-center" }

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { onMounted, ref } from 'vue'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const modalComplete = ref()
const platformName = ref<string>()

onMounted(() => {
  modalComplete.value = new Modal(document.getElementById('snsUnlinkCompleteDialog'))
})

expose({
  showCompleteModal: (platform): void => {
    platformName.value = platform
    modalComplete.value.show()
  },
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('SD40UnlinkConfirm')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.removeValid && _ctx.removeValid(...args)))
          })
        ]),
        (platformName.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(translate)('SD40UnlinkCompleteMessage').replaceAll('%s', _unref(translate)(`SD40${platformName.value}DisplayName`))), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(Button, {
            title: _unref(translate)('SE40close'),
            type: 'secondary',
            "data-bs-dismiss": "modal",
            onClick: _ctx.removeValid,
            "aria-label": "Close"
          }, null, 8, ["title", "onClick"])
        ])
      ])
    ])
  ]))
}
}

})